import { Service } from 'typedi';
import { BaseService, IBaseService, ServerResponse } from '../../../core/services/BaseService';
import { Appl } from '../../../core/Appl';

export interface ISecureFileUploadService extends IBaseService {
  getMemberInfoByUserIdAsync(userName: string): Promise<ServerResponse>;
  getUploadRequestByReqIdAndSecretAsync(reqId: number, secret: string): Promise<ServerResponse>;
  deleteMemberFileAsync(dociId: number): Promise<ServerResponse>;
}

@Service() // eslint-disable-next-line
export class SecureFileUploadService extends BaseService implements ISecureFileUploadService {
  constructor() {
    super(`${Appl.Setting.Services.MemberServiceUrl}`);
  }

  public async getMemberInfoByUserIdAsync(userName: string): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/mbase/member/MemberInfoByUserId/${userName}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getUploadRequestByReqIdAndSecretAsync(reqId: number, secret: string): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/members/secure-file-upload/upload-request/${reqId}/${secret}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async deleteMemberFileAsync(docDetailId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.delete(`/members/secure-file-upload/delete-member-file/${docDetailId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
}
